module.exports = __webpack_public_path__ + "static/panda_logo-b2e4fc94e538d078b518e8028ffbc7d4.png";